// extracted by mini-css-extract-plugin
module.exports = {"container":"_2mwzj0","circled-container":"_3oHRJY","circled":"_13LYtA","bezel":"_2EPA_z","circledBezel":"_2xemLe"};